<template>
  <div class="tw-rounded-lg tw-flex tw-flex-col tw-justify-between tw-p-4 hover:tw-shadow-sm" :class="classes">
    <div class="tw-flex tw-items-center tw-justify-middle tw-space-x-2 tw-mb-3">
      <i class="fas tw-text-2xl" :class="icon"></i>
      <strong class="tw-flex-1">{{ title }}</strong>
    </div>
    <div class="tw-text-sm">
      {{ subtitle }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'tw-stats-card',
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    outline: {
      type: Boolean,
      default: false
    },
    icon: String,
    title: String,
    subtitle: String,
  },
  computed: {
    classes() {
      return {
        default: this.outline
          ? 'tw-border-2 tw-border-gray-600 tw-bg-gray-100 tw-text-gray-600'
          : 'tw-border-0 tw-bg-gray-100 tw-text-gray-600',
        primary: this.outline
          ? 'tw-border-2 tw-border-blue-600 tw-bg-blue-100 tw-text-blue-600'
          : 'tw-border-0 tw-bg-blue-100 tw-text-blue-600',
        danger: this.outline
          ? 'tw-border-2 tw-border-red-600 tw-bg-red-100 tw-text-red-600'
          : 'tw-border-0 tw-bg-red-100 tw-text-red-600',
        success: this.outline
          ? 'tw-border-2 tw-border-green-600 tw-bg-green-100 tw-text-green-600'
          : 'tw-border-0 tw-bg-green-100 tw-text-green-600',
        warning: this.outline
          ? 'tw-border-2 tw-border-amber-600 tw-bg-amber-100 tw-text-amber-600'
          : 'tw-border-0 tw-bg-amber-100 tw-text-amber-600',
      }[this.type]
    }
  }
};
</script>
<style>
</style>
